import { useSyncExternalStore } from "react";
import { MOBILE_BREAKPOINT } from "@/utils/constants.ts";

const query = `(max-width: ${MOBILE_BREAKPOINT}px)`;

const subscribe = (onChange: () => void) => {
  const mediaQueryList = window.matchMedia(query);
  mediaQueryList.addEventListener("change", onChange);
  return () => mediaQueryList.removeEventListener("change", onChange);
};

const getSnapshot = () => window.matchMedia(query).matches;

export const useIsMobile = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot);
